import getUrls from './getUrls';
import { getLogoutUrl } from 'getUrls';

module.exports = {
  
  'home': getUrls.getHomeUrl(),
  
  'reports': getUrls.getReportListUrl(),
  
  'learners-portfolios': getUrls.getLearnerPortfolioListUrl(),
  
  'my-profile': getUrls.getMyProfileUrl(),
  
  'assessment': getUrls.getAssessmentsUrl(),
  
  'parent-share': getUrls.getParentShareUrl(),
  
  'logout': getLogoutUrl(),
  
};
